import { useState, useEffect } from 'react';

const A2HS_DISMISSED_KEY = 'liftlab_a2hs_dismissed';

function isStandalone() {
  if (typeof window === 'undefined') return true;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    document.referrer.includes('android-app://')
  );
}

function isMobile() {
  if (typeof window === 'undefined') return false;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
}

export default function AddToHomeScreen({ language, onDismiss }) {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    if (isStandalone()) return;
    if (!isMobile()) return;
    if (localStorage.getItem(A2HS_DISMISSED_KEY) === 'true') return;
    setVisible(true);
  }, [mounted]);

  function handleDismiss() {
    setVisible(false);
    localStorage.setItem(A2HS_DISMISSED_KEY, 'true');
    onDismiss?.();
  }

  if (!visible) return null;

  const copy = language === 'da'
    ? {
        title: 'Tilføj til startskærm',
        body: 'Få fuldskærmsoplevelse og hurtig adgang – tilføj LiftLab til din startskærm.',
        cta: 'Sådan gør du',
        dismiss: 'Ikke nu',
      }
    : {
        title: 'Add to Home Screen',
        body: 'Get a full-screen app experience and quick access – add LiftLab to your home screen.',
        cta: 'How to add',
        dismiss: 'Not now',
      };

  return (
    <div className="a2hs-banner" role="region" aria-label={copy.title}>
      <div className="a2hs-banner-inner">
        <div className="a2hs-banner-icon" aria-hidden>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="4" />
            <path d="M12 8v8M8 12h8" />
          </svg>
        </div>
        <div className="a2hs-banner-content">
          <p className="a2hs-banner-title">{copy.title}</p>
          <p className="a2hs-banner-body">{copy.body}</p>
          <p className="a2hs-banner-hint">
            {/iPhone|iPad|iPod/i.test(navigator.userAgent)
              ? (language === 'da' ? 'Safari: Del → "Tilføj til startskærm"' : 'Safari: Share → "Add to Home Screen"')
              : (language === 'da' ? 'Chrome: Menu ⋮ → "Tilføj til startskærm"' : 'Chrome: Menu ⋮ → "Add to Home screen"')}
          </p>
        </div>
        <button
          type="button"
          className="a2hs-banner-close"
          onClick={handleDismiss}
          aria-label={copy.dismiss}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
